import axios from 'axios';
import "firebase/compat/auth";
export const CALL_API_URL = `https://frozen-hollows-52574.herokuapp.com`;
    // const user = firebase.auth().currentUser;
export function deleteEvent(id, host, role, email) {
    if (role === "Teacher" || role === "Organizer" || host === email) { //change this to user.email
        axios({
            method: 'delete',
            url: `${CALL_API_URL}/api/events/${id}`,
            mode: 'cors',
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        });
        return;
    } else  {
        alert("You are not the host or do not have teacher/organizer status!");
    }
}

export  function deleteAttendee(attendeeId, eventId, host, email, attendeeEmail) {
    if (attendeeEmail === email || host === email) { //change this to user.email
        axios({
            method: 'delete',
            url: `${CALL_API_URL}/api/events/${eventId}/${attendeeId}`,
            mode: 'cors',
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        });
        // alert("RSVP deleted!");
        // window.location.reload();
        // return;
    } else  {
        alert("You are not the host or the attendee mentioned!");
    }
} 